import React, { useState, useEffect } from "react";
import "./EditProfile.css";
import { BASE_URL } from "../../api";
import Loader from "../../components/common/Loader";

function ProfileEdit() {
  const [profileData, setProfileData] = useState({ profile_pic: "" });
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [image, setImage] = useState();

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const imageData = event.target.result;
        setImage(imageData);
        setProfileData((prevState) => ({
          ...prevState,
          profile_pic: imageData,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchProfileData = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${BASE_URL}users/profile_me/`, {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      const data = await response.json();
      setProfileData(data.data);
      setIsLoading(false);
      // console.log(data.data); // log the fetched data
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setProfileData({
      ...profileData,
      [name]: value,
    });
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setIsSaving(true);

    try {
      let dataToSend = profileData;
      if (!image) {
        const { profile_pic, ...rest } = profileData;
        dataToSend = rest;
      }
      const token = localStorage.getItem("token");
      const response = await fetch(`${BASE_URL}users/edit_profile/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
          // Authorization: "Token 672b70e1805f2bffdd924556a36defbe488ffadb",
        },
        body: JSON.stringify(dataToSend),
      });
      // console.log(JSON.stringify(profileData));

      const data = await response.json();
      // console.log(data);
      setProfileData(data.data);
      setIsSaving(false);
    } catch (error) {
      console.error(error);
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return <Loader text="Loading profile..." />;
  }

  return (
    <form onSubmit={handleFormSubmit}>
      <div className="Edit_profile_section">
        <div className="Edit_Container">
          <h1>Profile</h1>
          <div className="floating-form">
            <div>
              <div className="profile-image-container">
                <div
                  className="profile-image"
                  // style={{ backgroundImage: `url(${image || profileData.profile_pic})` }}
                  style={{
                    backgroundImage: `url(${
                      image || profileData?.profile_pic
                    })`,
                  }}
                >
                  <label
                    htmlFor="profile-upload"
                    className="profile-image-edit"
                  >
                    <i className="fas fa-camera"></i>
                  </label>
                  <input
                    type="file"
                    id="profile-upload"
                    accept=".png, .jpg, .jpeg"
                    name="profile_pic"
                    //   value={profileData.profile_pic || ''}
                    onChange={handleImageChange}
                  />
                </div>
              </div>
            </div>
            <label htmlFor="Name">Full name: </label>
            <div className="Ep-details-palyer">
              <div className="floating-label">
                <input
                  id="Name"
                  className="floating-input"
                  type="text"
                  placeholder="Full Name "
                  name="full_name"
                  value={profileData?.full_name || ""}
                  onChange={handleInputChange}
                />
                {/* <button type="button" onClick={() => handleEditClick("full_name")}>
                Edit
              </button> */}
                <span className="highlight"></span>
              </div>
              <label htmlFor="mobile-ep">Mobile number: </label>
              <div className="floating-label">
                <input
                  id="mobile-ep"
                  placeholder="Phone"
                  className="floating-input"
                  type="tel"
                  name="mobile"
                  minLength="10"
                  maxLength="10"
                  value={profileData?.mobile || ""}
                  onChange={(e) => {
                    const re = /^[0-9\b]+$/; // regular expression to only allow numbers
                    if (e.target.value === "" || re.test(e.target.value)) {
                      handleInputChange(e);
                    }
                  }}
                />
                {/* <button type="button" onClick={() => handleEditClick("mobile")}>
                  Edit
                </button> */}
                <span className="highlight"></span>
              </div>
              <label htmlFor="email-ep">Email: </label>
              <div className="floating-label">
                <input
                  id="email-ep"
                  placeholder="Email"
                  className="floating-input"
                  type="email"
                  name="email"
                  value={profileData?.email || ""}
                  onChange={handleInputChange}
                />
                {/* <button type="button" onClick={() => handleEditClick("email")}>
                  Edit
                </button> */}
                <span className="highlight"></span>
              </div>
            </div>

            {/* ----------------------- */}
          </div>

          <button className="btn-ep" type="submit" disabled={isSaving}>
            {isSaving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </form>
  );
}

export default ProfileEdit;
